import dynamic from "next/dynamic";

import VideoPlayer          from "_components/features/player";
import LoginWall            from "_components/molecules/loginWall";
import { ENABLE_VIDEO_ADS } from "_config/index";

import useStyles from "./styles";

const PlayNext = dynamic ( () => import ( "./playNext" ) );

const component = props => {
	const {
		adTagURL,
		onVideoEnd,
		videoType,
		videoSrc,
		isVideoEnded,
		nextVideoItem,
		timeLeft,
		readTime,
		cancelClickHandler,
		playNowClickHandler,
		startTime,
		thumbnail
	} = props;

	const { classes } = useStyles ( { isVideoEnded }, { name: "media" } );

	return (
		<div className = { classes.videoPlayer }>

			<div className = { isVideoEnded ? classes.overlay : undefined } />

			<LoginWall
				background = { thumbnail }
				isVideo    = { true }
			>
				<VideoPlayer
					disableTheatreMode
					enableAds              = { ENABLE_VIDEO_ADS }
					handleCancelPlayNext   = { cancelClickHandler }
					muted                  = { false }
					onPlaybackEnd          = { onVideoEnd }
					overrideAdTag          = { adTagURL }
					readTime               = { readTime }
					sessionType            = "video"
					showControlsOnVideoEnd = { isVideoEnded }
					src                    = { videoSrc }
					startTime              = { startTime }
					thumbnail              = { thumbnail }
					type                   = { videoType === "video" ? "mp4" : null }
				/>
			</LoginWall>

			<PlayNext
				cancelClickHandler  = { cancelClickHandler }
				isVideoEnded        = { isVideoEnded }
				nextVideoItem       = { nextVideoItem }
				playNowClickHandler = { playNowClickHandler }
				timeLeft            = { timeLeft }
			/>

		</div>
	);
};

export default component;
